import axios from "axios";

const BASE_URL = `${process.env.API_URL}/start-game`;

export interface OpenAIBook {
  number: number;
  title: string;
  author: string;
  img: string;
  description: string;
}

export interface Category {
  category_name: string;
  books: OpenAIBook[];
}

export interface Response {
  categories: Category[];
  pickedDate: string;
}

export async function fetchBooks(): Promise<Response | undefined> {
  console.log("hits fetch books");
  // Fetch the list of categories
  try {
    const { data } = await axios.get<{
      categories: Category[];
      picked_date: string;
    }>(BASE_URL, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    console.log({ data });

    console.log(data.categories);

    return {
      categories: data.categories,
      pickedDate: data.picked_date,
    };
  } catch (error) {
    console.log({ error });
  }
}
